import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import TermsAndConditions from "./page/TermsAndConditions";
import ContactUs from "./page/ContactUs";
import MobileTerms from "./page/MobileTerms";
import LoginPage from './page/Login';

function App() {
  return (
     
      <div className="min-h-screen bg-gray-100 p-4">
        <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/dashboard" element={<Header />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/privacy" element={<TermsAndConditions />} />
          <Route path="/terms" element={<MobileTerms />} />
          
        </Routes>
      </div>
  
  );
}

export default App;